import React, { useRef, useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useClickOutside(ref, onClickOutside) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                onClickOutside();
            }
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, onClickOutside]);
}

/**
 * Component that alerts if you click outside of it
 */
function ClickOutside({ onClickOutside, children, className = '' }) {
    const wrapperRef = useRef(null);
    useClickOutside(wrapperRef, onClickOutside);

    return (
        <div className={`click-outside-wrapper ${className || ''}`} ref={wrapperRef}>
            {children}
        </div>
    );
}

export default ClickOutside;
